<template>
  <div class="ss__notifications__popover__wrapper">
    <div class="ss__notifications__popover">
      <div v-if="isBlank" class="ss__notifications__popover__blank">暂无新通知</div>
      <div v-else class="ss__notifications__popover__header">新通知</div>
      <template v-for="item in reminders">
        <a
          v-if="item.count"
          :key="item.name"
          class="ss__notifications__popover__item"
          :href="item.link">
          <i :class="['ss__notifications__popover__item__icon', item.icon]"/>
          <span class="ss__notifications__popover__item__name">{{ item.name }}</span>
          <span
            :class="[
              'ss__notifications__popover__item__count',
              item.count > 9 ? 'twoDigit' : 'oneDigit'
            ]">
            {{ formatCount(item.count) }}
          </span>
        </a>
      </template>
      <a class="ss__notifications__popover__link__all" href="/notifications">
        <span>查看全部</span>
        <i class="ssCommunityIcon__arrowMore"/>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SsNotificationsPopover',

  props: {
    notifications: {
      type: Object,
      default: () => (
        {
          reaction: 0,
          comment: 0,
          system: 0,
          community: 0,
          message: 0
        }
      )
    }
  },

  computed: {
    isBlank () {
      let temp = 0
      for (const [, value] of Object.entries(this.notifications)) {
        temp += (value || 0)
      }
      return !temp
    },
    reminders () {
      const { reaction, comment, system, community, message } = this.notifications
      return [
        { name: '回应', icon: 'ssCommunityIcon__lightning', count: reaction, link: '/notifications/activity/like' },
        { name: '评论', icon: 'ssCommunityIcon__chatBubble', count: comment, link: '/notifications/activity/comment' },
        { name: '系统通知', icon: 'ssCommunityIcon__broadcast', count: system, link: '/notifications/system' },
        { name: '社区互动', icon: 'ssCommunityIcon__community', count: community, link: '/notifications/activity/community' },
        { name: '私信', icon: 'ssCommunityIcon__mail', count: message, link: '/notifications/message' }
      ]
    }
  },

  methods: {
    formatCount (v) {
      if (v > 99) {
        return '99+'
      }
      return v
    }
  }
}
</script>

<style lang="stylus" scoped>
.ss__notifications__popover {
  position: relative;
  z-index: 2;
  width: 298px;
  margin: auto;
  border-radius: 16px;
  border: 1px solid var(--B2-t-overlay);
  background: var(--B0-t-overlay);
  box-shadow: var(--shadow-level-3);
  overflow: hidden;

  color: var(--B8-t);
  font-size: 13px;
  font-weight: 500;
  line-height: normal;

  a {
    color: inherit;
    &:hover {
      color: inherit;
    }
  }
}

.ss__notifications__popover__blank {
  color: var(--B6-t-overlay);
  font-size: 15px;
  font-weight: 500;
  padding: 20px;
}

.ss__notifications__popover__header {
  color: var(--B8-t);
  padding: 20px;
  font-size: 15px;
  font-weight: 500;
  padding: 20px;
}

.ss__notifications__popover__link__all {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  padding: 12px 20px;
  border-top: 1px solid var(--B2-t-overlay);
  margin-top: 8px;
  transition: background .2s;
  &:hover, &:focus {
    background: var(--B1-t-overlay);
  }
  .ssCommunityIcon__arrowMore {
    font-size: 20px;
  }
}

.ss__notifications__popover__item {
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 12px 20px;
  transition: background .2s;
  &:hover, &:focus {
    background: var(--B1-t-overlay);
  }
  .ss__notifications__popover__item__icon {
    font-size: 20px;
  }
  .ss__notifications__popover__item__count {
    margin-left: auto;
    border-radius: 6px;
    background: var(--red-t);
    color: #fff;
    text-align: center;
    font-size: 13px;
    line-height: 20px;
    font-weight: 500;
    display: inline-block;
    &.oneDigit {
      width: 22px;
    }
    &.twoDigit {
      width: 32px;
    }
  }
}
</style>
